import { useQuery } from '@tanstack/react-query';
import { queryTuning } from '@/lib/query';
import { supabase } from '@/lib/supabase';
import type { Database } from '@/types/supabase';

export type TickerRow = Pick<
  Database['public']['Tables']['ticker']['Row'],
  | 'id'
  | 'symbol'
  | 'name'
  | 'sector'
  | 'industry'
  | 'market_cap'
  | 'last_price'
  | 'last_price_change_pct'
  | 'buzz_score'
  | 'buzz_computed_at'
>;

const TICKER_COLUMNS =
  'id,symbol,name,sector,industry,market_cap,last_price,last_price_change_pct,buzz_score,buzz_computed_at';

async function fetchTickers(): Promise<TickerRow[]> {
  const { data, error } = await supabase
    .from('ticker')
    .select(TICKER_COLUMNS)
    .eq('active', true)
    .order('market_cap', { ascending: false, nullsFirst: false })
    .limit(100);
  if (error) throw error;
  return (data ?? []) as TickerRow[];
}

export function useTickers() {
  return useQuery({
    queryKey: ['tickers', 'list', 'v1'],
    queryFn: fetchTickers,
    ...queryTuning.list,
  });
}
